import http from '~/common/http'
export default {
    confirmPfm(data) {
        return http.put("/api/user-orders/confirm-pfm", data);
    },

    updatePfm(data) {
        return http.put("/api/user-orders/update-pfm", data);
    },

    takeOver(data) {
        return http.put("/api/user-orders/take-over", data);
    },
}


// WEBPACK FOOTER //
// ./src/services/UserOrders.js